import { useIsMutating } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { ScrollShadow } from '@ds';
import { OnScreenLoader, NotificationBadge } from '@ui';
import { ConnectedCaseTab } from '@features/components/ConnectedCaseTab';
import { useCaseTabs } from '@lp/core/hooks/useCaseTabs';

export const CaseLayout = () => {
  const { tabsList, checkCurrentCase, openCaseDetails, onTabRemove, reorderTab } = useCaseTabs();
  const isMutating = useIsMutating({ predicate: (mutation) => !!mutation.meta?.isGlobalLoader });

  return (
    <div className="flex flex-col grow bg-base-60 h-full relative">
      {!!isMutating && <OnScreenLoader />}

      <div className="flex px-4 py-2 gap-2 shrink-0">
        <ScrollShadow orientation="horizontal" hideScrollBar>
          <div className="flex grow">
            {tabsList.map((item) => (
              <ConnectedCaseTab
                id={item.id}
                key={item.id}
                donorId={item.donorId}
                caseSuffixes={item.caseSuffixes}
                organType={item.organType}
                checkCurrentCase={checkCurrentCase}
                onClick={openCaseDetails}
                onRemove={onTabRemove}
                onReorder={reorderTab}
              />
            ))}
          </div>
        </ScrollShadow>

        <NotificationBadge />
      </div>

      <Outlet />
    </div>
  );
};
